import React from 'react';

const EventsList = ({ events, loading, error, onViewEvent, extractSportFromEventName }) => {
  if (error) {
    return (
      <div style={{
        backgroundColor: '#f8d7da',
        color: '#721c24',
        padding: '12px',
        borderRadius: '4px',
        marginBottom: '20px',
        textAlign: 'center'
      }}>
        {error}
      </div>
    );
  }

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '20px' }}>
        Loading events...
      </div>
    );
  }

  if (events.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '20px', color: '#6c757d' }}>
        No events found for the selected criteria.
      </div>
    );
  }

  return (
    <div>
      <h2 style={{ marginBottom: '20px' }}>
        Available Events ({events.length})
      </h2>
      
      <div style={{ display: 'grid', gap: '15px' }}>
        {events.map((event, index) => (
          <div
            key={index}
            style={{
              backgroundColor: 'white',
              border: '1px solid #dee2e6',
              borderRadius: '8px',
              padding: '20px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ flex: 1 }}>
                <h3 style={{ margin: '0 0 10px 0', color: '#333', fontSize: '1.2em' }}>
                  {event.event_name}
                </h3>
                <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <span style={{ fontWeight: 'bold', color: '#6c757d' }}>Sport:</span>
                    <span style={{
                      backgroundColor: '#17a2b8',
                      color: 'white',
                      padding: '3px 8px',
                      borderRadius: '4px',
                      fontSize: '0.85em'
                    }}>
                      {extractSportFromEventName(event.event_name)}
                    </span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <span style={{ fontWeight: 'bold', color: '#6c757d' }}>Date:</span>
                    <span>{new Date(event.event_date).toLocaleDateString()}</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <span style={{ fontWeight: 'bold', color: '#6c757d' }}>Contests:</span>
                    <span style={{
                      backgroundColor: '#ffc107',
                      color: '#212529',
                      padding: '3px 8px',
                      borderRadius: '4px',
                      fontSize: '0.85em',
                      fontWeight: 'bold'
                    }}>
                      {event.contests.length}
                    </span>
                  </div>
                </div>
              </div>
              <button
                onClick={() => onViewEvent(event)}
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#007bff',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '1em',
                  fontWeight: 'bold',
                  marginLeft: '20px'
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
                onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
              >
                View Contests
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EventsList;
